export default "__VITE_PUBLIC_ASSET__b92da50f__"